<p-dialog
  [header]="'Adres'"
  [modal]="modal"
  [(visible)]="visible"
  [closable]="false"
  [style]="{ width: '45rem' }"
>
  <div class="modal-body" style="max-height: 60vh; overflow-y: auto">
    <div class="d-flex justify-content-end">
      <div class="form-check form-switch">
        <input
          class="form-check-input"
          type="checkbox"
          [(ngModel)]="isManualAddress"
          (ngModelChange)="onManualAddressChange()"
          id="manualAddressSwitch"
        />
        <label class="form-check-label" for="isManualAddress">
          {{ "address.manuel-address" | translate }}
        </label>
      </div>
    </div>

    <div class="row" *ngIf="!this.isManualAddress" [formGroup]="addressForm">
      <div class="row">
        <div class="col-xl-12 mb-1">
          <label for="formattedAddress" class="form-label"
            >{{ "address.address" | translate
            }}<span class="text-danger">*</span></label
          >
          <input
            #addressInput
            type="text"
            class="form-control"
            placeholder="Açık Adres"
            formControlName="formattedAddress"
          />
        </div>
        <div
          *ngIf="addressForm.get('formattedAddress')?.hasError('required')"
          class="text-danger"
        >
          <small
            *ngIf="addressForm.get('formattedAddress')?.errors?.['required']"
            >{{ "validation.required" | translate }}</small
          >
        </div>
      </div>
      <div class="row mb-1" *ngIf="showCountryPicker">
        <div class="col-xl-12">
          <label for="country" class="form-label">
            {{ "address.country" | translate }}
          </label>
          <input
            type="text"
            class="form-control"
            placeholder="Ülke"
            formControlName="country"
          />
        </div>
        <div
          *ngIf="addressForm.get('country')?.hasError('required')"
          class="text-danger"
        >
          <small *ngIf="addressForm.get('country')?.errors?.['required']">{{
            "validation.required" | translate
          }}</small>
        </div>
      </div>
      <div class="row mb-1">
        <div class="col-xl-6">
          <label for="city" class="form-label">
            {{ "address.city" | translate }}
            <span class="text-danger">*</span>
          </label>
          <input
            type="text"
            class="form-control"
            placeholder="İl"
            formControlName="city"
          />
          <div
            *ngIf="addressForm.get('city')?.hasError('required')"
            class="text-danger"
          >
            <small *ngIf="addressForm.get('city')?.errors?.['required']">{{
              "validation.required" | translate
            }}</small>
          </div>
        </div>
        <div class="col-xl-6">
          <label for="district" class="form-label">
            {{ "address.district" | translate }}
            <span class="text-danger">*</span>
          </label>
          <input
            type="text"
            class="form-control"
            placeholder="İlçe"
            formControlName="district"
          />

          <div
            *ngIf="addressForm.get('district')?.hasError('required')"
            class="text-danger"
          >
            <small *ngIf="addressForm.get('district')?.errors?.['required']">{{
              "validation.required" | translate
            }}</small>
          </div>
        </div>
      </div>

      <div class="row mb-1">
        <div class="col-xl-6">
          <label for="postalCode" class="form-label">
            {{ "address.postal-code" | translate }}
          </label>
          <input
            type="text"
            class="form-control"
            placeholder="Posta Kodu"
            formControlName="postalCode"
          />
        </div>
        <div class="col-xl-6">
          <label for="street" class="form-label">
            {{ "address.street" | translate }}
          </label>
          <input
            type="text"
            class="form-control"
            placeholder="Sokak"
            formControlName="street"
          />
        </div>
      </div>
      <div class="row mb-1">
        <div class="col-xl-6">
          <label for="latitude" class="form-label">
            {{ "address.latitude" | translate }}
          </label>
          <input
            type="text"
            class="form-control"
            placeholder="Latitude"
            formControlName="latitude"
          />
        </div>
        <div class="col-xl-6">
          <label for="longitude" class="form-label">
            {{ "address.longitude" | translate }}
          </label>
          <input
            type="text"
            class="form-control"
            placeholder="Longitude"
            formControlName="longitude"
          />
        </div>
        <div class="col-xl-12">
          <label for="addressDescription" class="form-label">
            {{ "address.address-description" | translate }}
          </label>
          <textarea
            formControlName="addressDescription"
            class="form-control"
            rows="3"
            id="addressDescription"
            placeholder="Adres açıklaması giriniz..."
          ></textarea>
        </div>
      </div>

      <!-- Address Inputs -->
    </div>

    <div *ngIf="this.isManualAddress">
      <div class="row">
        <div class="col-xl-12 mb-1">
          <label for="formattedAddress" class="form-label"
            >{{ "address.address" | translate
            }}<span class="text-danger">*</span></label
          >
          <input
            type="text"
            class="form-control"
            placeholder="Açık Adres"
            [(ngModel)]="manuelFormattedAddress"
          />
        </div>
      </div>
      <div class="row mb-1">
        <div class="col-xl-12" *ngIf="showCountryPicker">
          <label for="manuelCountry" class="form-label">
            {{ "address.country" | translate }}
          </label>
          <p-dropdown
            [options]="countries"
            [(ngModel)]="manuelCountry"
            [showClear]="true"
            [filter]="true"
            optionLabel="label"
            [placeholder]="'general.select-please' | translate"
            (ngModelChange)="onCountryChanged($event)"
          >
          </p-dropdown>
        </div>
      </div>
      <div class="row mb-1">
        <div class="col-xl-6 col-sm-12">
          <label for="manuelCity" class="form-label">
            {{ "address.city" | translate }}
            <span class="text-danger">*</span>
          </label>
          <p-dropdown
            [options]="filteredCities"
            [(ngModel)]="manuelCity"
            [showClear]="true"
            [filter]="true"
            optionLabel="label"
            [placeholder]="'general.select-please' | translate"
            (ngModelChange)="onCityChanged($event)"
          >
          </p-dropdown>
        </div>
        <div class="col-xl-6 col-sm-12">
          <label for="manuelDistrict" class="form-label">
            {{ "address.district" | translate }}
            <span class="text-danger">*</span>
          </label>
          <p-dropdown
            [options]="filteredDistricts"
            [(ngModel)]="manuelDistrict"
            [showClear]="true"
            [filter]="true"
            optionLabel="label"
            [placeholder]="'general.select-please' | translate"
            (ngModelChange)="onDistrictChanged($event)"
          >
          </p-dropdown>
        </div>
      </div>

      <div class="row mb-1">
        <div class="col-xl-6">
          <label for="postalCode" class="form-label">
            {{ "address.postal-code" | translate }}
          </label>
          <input
            type="text"
            class="form-control"
            placeholder="Posta Kodu"
            [(ngModel)]="manuelPostalCode"
          />
        </div>
        <div class="col-xl-6">
          <label for="street" class="form-label">
            {{ "address.street" | translate }}
          </label>
          <input
            type="text"
            class="form-control"
            placeholder="Sokak"
            [(ngModel)]="manuelStreet"
          />
        </div>
      </div>

      <div class="row mb-1">
        <div class="col-xl-6">
          <label for="latitude" class="form-label">
            {{ "address.latitude" | translate }}
          </label>
          <input
            type="text"
            class="form-control"
            placeholder="Latitude"
            [(ngModel)]="manuelLatitude"
          />
        </div>
        <div class="col-xl-6">
          <label for="longitude" class="form-label">
            {{ "address.longitude" | translate }}
          </label>
          <input
            type="text"
            class="form-control"
            placeholder="Longitude"
            [(ngModel)]="manuelLongitude"
          />
        </div>
      </div>
      <div class="col-xl-12">
        <label for="addressDescription" class="form-label">
          {{ "address.address-description" | translate }}
        </label>
        <textarea
          [(ngModel)]="manuelDescription"
          class="form-control"
          rows="3"
          placeholder="Adres açıklaması giriniz..."
        ></textarea>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-danger"
      style="margin-right: 3%"
      (click)="closeDialog()"
    >
      {{ "common.cancel" | translate }}
    </button>
    <button type="button" class="btn btn-success" (click)="saveAddress()">
      {{ "common.save" | translate }}
    </button>
  </div>
</p-dialog>
